import { Autocomplete, Checkbox } from "@shopify/polaris"
import React, { useEffect, useState } from "react"
import { useTranslation } from "react-i18next"

export const roundPrice = (price, roundTo) => {
	if (price < 1) {
		return Math.floor(price) + parseFloat(roundTo)
	} else if (Math.round(price) > Math.floor(price)) {
		if (Math.round(roundTo) > Math.floor(roundTo)) {
			return Math.floor(price) + parseFloat(roundTo)
		} else {
			return (
				Math.floor(price) +
				(parseFloat(roundTo) > 0 ? 1 : 0) +
				parseFloat(roundTo)
			)
		}
	} else {
		if (Math.round(roundTo) > Math.floor(roundTo)) {
			return (
				Math.floor(price) -
				(price !== 0 && parseFloat(roundTo) > 0 ? 1 : 0) +
				parseFloat(roundTo)
			)
		} else {
			return Math.floor(price) + parseFloat(roundTo)
		}
	}
}

export default function PriceRounding(props) {
	const { t } = useTranslation()
	const [roundingEnabled, setRoundingEnabled] = useState(false)
	const [roundingNumber, setRoundingNumber] = useState(null)
	const [selectedOption, setSelectedOption] = useState(["0.99"])

	useEffect(() => {
		setRoundingEnabled(props.roundingEnabled)
	}, [props.roundingEnabled])

	useEffect(() => {
		setRoundingNumber(props.roundingNumber)
		setSelectedOption([props.roundingNumber])
	}, [props.roundingNumber])

	return (
		<>
			<div
				style={{
					display: "flex",
					flexDirection: "column",
					gap: "1rem",
				}}
			>
				<Checkbox
					checked={roundingEnabled}
					onChange={() => {
						setRoundingEnabled(!roundingEnabled)
						props.onCheckedChanged(!roundingEnabled)
					}}
					label={t("other.round_product_prices")}
				/>
				<Autocomplete
					options={[
						{ value: "0.99", label: "0.99" },
						{ value: "0.95", label: "0.95" },
						{ value: "0.90", label: "0.90" },
						{ value: "0", label: "0.00" },
					]}
					onSelect={(sel) => {
						if (sel?.length && sel?.[0]) {
							setSelectedOption(sel)
							setRoundingNumber(sel[0])
							props.onRoundingNumberChange(sel[0])
						}
					}}
					selected={selectedOption}
					textField={
						<Autocomplete.TextField
							autoComplete="off"
							disabled={!roundingEnabled}
							label={t("other.rounding_to_number")}
							placeholder={t(
								"other.select_a_number_to_round_to_or_type_your_own",
							)}
							onChange={(n) => {
								if (isNaN(n) || n > 0.99) return
								setRoundingNumber(n === "" ? null : n)
								props.onRoundingNumberChange(
									n === "" ? null : n,
								)
							}}
							value={
								roundingEnabled ? selectedOption?.[0] || "" : ""
							}
						/>
					}
				/>
			</div>
		</>
	)
}
